/**
 * Analytics & Reports — shared lookups for the library screens.
 *
 * DEMO. See `DEMO-MODE.md` §8.9.
 *
 * Tone comes off the category through a static map for the reason written at
 * the top of `lib/tone.js`: a class built from a template literal is never
 * generated by Tailwind's scanner and renders nothing at all.
 */

/** Category → the hue it is filed under. Token names, never literals. */
export const CATEGORY_TONE = {
  oee: 'forge',
  reliability: 'amber',
  quality: 'green',
  energy: 'watch',
  safety: 'red',
  cost: 'violet',
  production: 'ack',
  inventory: 'dismissed',
}

/** The dot beside a category heading. Same map, resolved statically. */
export const CATEGORY_DOT = {
  forge: 'bg-forge',
  amber: 'bg-amber',
  green: 'bg-green',
  watch: 'bg-watch',
  red: 'bg-red',
  violet: 'bg-violet',
  ack: 'bg-ack',
  dismissed: 'bg-dismissed',
}

/**
 * A template's display name.
 *
 * The catalogue number is the fallback rather than a made-up string: an R-code
 * with no translation is still the identifier a plant refers the report by, so
 * a missing key degrades to something a reader can act on.
 */
export const templateName = (t, id) => t(`app:reports.template.${id}.name`, { defaultValue: id })

export const templateDesc = (t, id) => t(`app:reports.template.${id}.desc`, { defaultValue: '' })

/**
 * The standard a report is written against.
 *
 * Passed through untranslated when it is a specification number — "ISO 22400"
 * is the same string in every locale, and routing it through the catalogue
 * would invite somebody to localise a standard's name, which is wrong.
 */
export const standardLabel = (t, standard) =>
  t(`app:reports.standard.${standard}`, { defaultValue: standard })

/** The cadences a template is normally run at, joined for a card. */
export const cadenceLabel = (t, cadences) =>
  (cadences ?? []).map((entry) => t(`app:reports.cadence.${entry}`)).join(' · ')
